import { render, staticRenderFns } from "./RecShareSetting.vue?vue&type=template&id=59fb7295&scoped=true"
import script from "./RecShareSetting.vue?vue&type=script&lang=js"
export * from "./RecShareSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59fb7295",
  null
  
)

export default component.exports